// SodInstallationServices.js
import React from 'react';
import { Box, Grid, Typography, Card, CardMedia, CardContent, Container } from '@mui/material';

const Examples = () => {
  const benefits = [
    {
      title: 'Instant Results',
      description: 'Sod provides a fully established lawn immediately after installation. Unlike grass seed, which can take months or even years to grow and fill in, sod gives instant curb appeal and functionality.',
      image: 'https://elasticbeanstalk-us-west-2-713881798821.s3.us-west-2.amazonaws.com/sod_example.jpeg',
    },
    {
      title: 'Durability & Protection',
      description: 'Sod provides a thick, dense lawn that makes it harder for weeds to grow. It acts as a natural weed barrier compared to grass seed, which often competes with weeds as it germinates.',
      image: 'https://elasticbeanstalk-us-west-2-713881798821.s3.us-west-2.amazonaws.com/sod_example2.jpeg',
    }
  ];

  return (
    <Box
      component="section"
      aria-labelledby="sod-benefits"
      sx={{
        py: { xs: 4, md: 6 },
        backgroundColor: 'white',
      }}
    >
      <Container>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: 700, mb: 3, textAlign: 'center' }}
        >
          Benefits of Sod Installation
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={5} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: 3,
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="320"
                  image={benefit.image}
                  alt={benefit.title}
                  sx={{
                    objectPosition: benefit.title === 'Durability & Protection' ? 'center bottom' : 'center',
                    objectFit: 'cover'
                  }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#000000' }}>
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Examples;